module.exports = __webpack_public_path__ + "static/img/48.c9401f6c.png";